import { ofType } from "redux-observable";
import { combineLatest, EMPTY, from, merge } from "rxjs";
import { filter, switchMap, take } from "rxjs/operators";
import { selectAutoSelectedExpansionId, selectExpansionXYFromIdGlobal, } from "../../../../selectors/selectUnlockableExpansionIds";
import { actionModalCloseAll } from "../../../modals/actionModal";
import { actionExpansionHighlight } from "../../../player-base/expansions/actionExpansions";
import { actionViewportCenterOn } from "../../../viewport/actionViewport";
import { TypeActionShowMe } from "../../actionShowMe";
export var epicShowMeHaveExpansion = function (action$, state$, deps) {
    var showMeAction$ = action$.pipe(ofType(TypeActionShowMe.QuestTaskHaveExpansion));
    var viewport$ = deps.inStoreDependencies.viewportChanged$.pipe(filter(function (viewport) { return !!viewport; }), take(1));
    return combineLatest(showMeAction$, viewport$).pipe(switchMap(function (_a) {
        var action = _a[0], viewport = _a[1];
        var state = state$.value;
        var expansionId = selectAutoSelectedExpansionId(state);
        if (expansionId == undefined) {
            return EMPTY;
        }
        var pos = selectExpansionXYFromIdGlobal(state, expansionId, viewport);
        return merge(from([
            actionModalCloseAll(),
            actionExpansionHighlight(expansionId),
            actionViewportCenterOn(pos, true),
        ]));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/have-expansion/epicShowMeHaveExpansion.ts
// module id = 2381
// module chunks = 3